/* eslint-disable @typescript-eslint/no-unused-vars */
import axios, {AxiosRequestConfig} from 'axios';
import {Glum} from 'puddleglum';
import {transformToQueryString, PaginatedResponse} from 'puddleglum/utils';

export default class VoucherController {
	static async index(
		request: Glum.Requests.Provider.SearchVouchersRequest = {} as Glum.Requests.Provider.SearchVouchersRequest,
		validationOnly: boolean = false,
		fieldToValidate: string = '',
		config: AxiosRequestConfig = {},
	) {
		return axios.get<PaginatedResponse<Glum.Models.Voucher>>(
			`/api/provider/vouchers?${transformToQueryString(request)}`,
			{
				headers: {
					Precognition: validationOnly,
					...(fieldToValidate ? {'Precognition-Validate-Only': fieldToValidate} : {}),
				},
				...config,
			},
		);
	}

	static async redeem(
		voucher: string | number,
		request: Glum.Requests.Provider.RedeemVoucherRequest = {} as Glum.Requests.Provider.RedeemVoucherRequest,
		validationOnly: boolean = false,
		fieldToValidate: string = '',
		config: AxiosRequestConfig = {},
	) {
		return axios.post<Glum.Models.Voucher>(
			`/api/provider/vouchers/${voucher}/redeem`,
			request,
			{
				headers: {
					Precognition: validationOnly,
					...(fieldToValidate ? {'Precognition-Validate-Only': fieldToValidate} : {}),
				},
				...config,
			},
		);
	}

	static async cancel(
		voucher: string | number,
		request: Glum.Requests.Provider.CancelVoucher = {} as Glum.Requests.Provider.CancelVoucher,
		validationOnly: boolean = false,
		fieldToValidate: string = '',
		config: AxiosRequestConfig = {},
	) {
		return axios.post<Glum.Models.Voucher>(
			`/api/provider/vouchers/${voucher}/cancel`,
			request,
			{
				headers: {
					Precognition: validationOnly,
					...(fieldToValidate ? {'Precognition-Validate-Only': fieldToValidate} : {}),
				},
				...config,
			},
		);
	}
}
